import { render, staticRenderFns } from "./BillingWidget.vue?vue&type=template&id=c3ec7992&scoped=true"
import script from "./BillingWidget.ts?vue&type=script&lang=ts&external"
export * from "./BillingWidget.ts?vue&type=script&lang=ts&external"
import style0 from "./BillingWidget.vue?vue&type=style&index=0&id=c3ec7992&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ec7992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3ec7992')) {
      api.createRecord('c3ec7992', component.options)
    } else {
      api.reload('c3ec7992', component.options)
    }
    module.hot.accept("./BillingWidget.vue?vue&type=template&id=c3ec7992&scoped=true", function () {
      api.rerender('c3ec7992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/components/BillingSection/BillingWidget/BillingWidget.vue"
export default component.exports